<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div class="container-client">
    <div class="header">
      <h1 class="title">{{'CLIENT' | translate}}</h1>
      <button class="btn primary-btn" (click)="resendVerificationEmail()" *ngIf="!client.authenticated && client.username != ''"> {{'RESEND_VERIFICATION_EMAIL' | translate}} </button>
      <!-- <button class="btn primary-btn" (click)="changeAccountAccess(1)" *ngIf="client.disabledAccount == 0 "> {{'DISABLED_ACCOUNT' | translate}} </button>
      <button class="btn primary-btn" (click)="changeAccountAccess(0)" *ngIf="client.disabledAccount == 1 "> {{'ENABLED_ACCOUNT' | translate}} </button> -->
      <app-back-arrow [route]="'/clients'"></app-back-arrow>
    </div>
    <div class="form-card">
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <div *ngIf="!loading" class="content row">
        <div class="title">
          <span>{{'INFORMATION' | translate}}</span>
        </div>
        <div class="column col-md-3">
          <label class="form-label" for="">{{'NAME' | translate}}</label>
        <input class="form-control" type="text" value="{{ client?.firstName || '' }}" disabled>
        </div>
        <div class="column col-md-3">
          <label class="form-label" for="">{{ 'LAST_NAME' | translate }}</label>
          <input class="form-control" type="text" value="{{ client?.lastName }}" disabled>
        </div>
        <div class="column col-md-3">
          <label class="form-label" for="">{{ 'GENDER' | translate }}</label>
          <div class="">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="gender" id="" value="male" [checked]="client?.gender == 'male'" disabled>
              <label class="form-check-label" for="">{{ 'MALE' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="gender" id="" value="female" [checked]="client?.gender == 'female'" disabled>
              <label class="form-check-label" for="">{{ 'FEMALE' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="column col-md-3" *ngIf="client.registrationDate">
          <label class="form-label" for="">{{ 'REGISTRATION_DATE' | translate }}</label>
          <input class="form-control" type="text" value="{{ formatDate(client?.registrationDate) }}" disabled>
        </div>
        <div class="column col-md-6">
          <label class="form-label" for="">{{'EMAIL' | translate}}</label>
        <!-- <input class="form-control" type="text" value="{{ client?.email }}" disabled> -->
          <div class="input-group mb-3">
            <input class="form-control" type="text" value="{{ showEmail ? client?.email : client?.emailMasked }}" disabled aria-describedby="email-field">
            <div class="input-group-append">
              <span class="input-group-text" id="email-field">
                <button
                  type="button"
                  class="btn p-1"
                  (click)="showEmail = !showEmail"
                  [attr.aria-label]="showEmail ? 'Ocultar correo' : 'Mostrar correo'"
                >
                  <i
                    class="bi"
                    [ngClass]="showEmail ? 'bi-eye' : 'bi-eye-slash'" 
                  ></i>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="column col-md-6">
          <label class="form-label" for="">{{'PHONE' | translate}}</label>
        <!-- <input class="form-control" type="text" value="{{ client?.phone }}" disabled> -->
          <div class="input-group mb-3">
            <input class="form-control" type="text" value="{{ showPhone ? client?.phone : client?.phoneMasked }}" disabled aria-describedby="phone-field">
            <div class="input-group-append">
              <span class="input-group-text" id="phone-field">
                <button
                  type="button"
                  class="btn p-1"
                  (click)="showPhone = !showPhone"
                  [attr.aria-label]="showPhone ? 'Ocultar teléfono' : 'Mostrar teléfono'"
                >
                  <i
                    class="bi"
                    [ngClass]="showPhone ? 'bi-eye' : 'bi-eye-slash'" 
                  ></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-card" *ngIf="shopSubscription?.shopPlanAllow?.beneficiariesBO">
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <div class="title" *ngIf="!loading">
        <span>{{'CLIENT_BENEFICIARIES' | translate}}</span>
      </div>
      <div class="no-orders" *ngIf="beneficiaries.length == 0">
        <span>{{'NO_BENEFICIARIES_TEXT' | translate}}</span>
      </div>
      <div class="col-md-12 d-flex" *ngIf="!loading && beneficiaries.length > 0">
        <div class="col-md-4">
          <ul class="">
            <li class="h5" *ngFor="let beneficiary of beneficiaries; let i = index" [ngClass]="{'d-none': i % 3 !== 0}">
              {{ beneficiary.beneficiaryName }}
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="">
            <li class="h5" *ngFor="let beneficiary of beneficiaries; let i = index" [ngClass]="{'d-none': i % 3 !== 1}">
              {{ beneficiary.beneficiaryName }}
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="">
            <li class="h5" *ngFor="let beneficiary of beneficiaries; let i = index" [ngClass]="{'d-none': i % 3 !== 2}">
              {{ beneficiary.beneficiaryName }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="form-card">
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <div class="title" *ngIf="!loading">
        <span>{{'CLIENT_ORDERS' | translate}}</span>
      </div>
      <div class="content container-fluid" *ngIf="!loading">
        <div class="no-orders" *ngIf="sales.length == 0">
          <span>{{'NO_ORDERS_TEXT' | translate}}</span>
        </div>
        <div class="col-sm-12 sale-card" *ngFor="let sale of sales">
          <div class="sale-card-header">
            <span class="header-title">
              {{'ORDER' | translate}} #{{ sale.saleShortCode }}
            </span>
            <span class="header-date">
              {{ sale.saleOnlyDate }}
            </span>
          </div>
          <div class="sale-card-body">
            <div class="sale-card-info">
              <span class="info-title">
                {{"STATUS" | translate}}:
              </span>
              <span class="status">
                {{ saleStateName[sale.saleState] }}
              </span>
            </div>
            <div class="sale-card-info">
              <span class="info-title">
                {{'DELIVERY_TIPE' | translate}}:
              </span>
              <span class="shipping">
                {{ sale.expressShipping == 1 ? "Envío a domicilio" : "Recoger en tienda" }}
              </span>
            </div>
            <div class="sale-card-info">
              <span>
                <button class="btn primary-btn" [routerLink]="['/orders/', sale.saleId]">
                  {{ 'GO_TO_ORDER' | translate }}
                </button>
              </span>
            </div>
            <div class="card-price">
              <span class="price-title">
                {{'TOTAL' | translate}}
              </span>
              <span class="amount">
                {{ appComponent.formatMoney(sale.saleEndPrice) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
<div class="form-card" *ngIf="!loading && hasPlans && shopSubscription?.shopPlanAllow?.plansByClientBO">

  <div class="title">
    <span>{{ 'CLIENT_PLANS' | translate }}</span>
  </div>

  <div class="content container-fluid">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="table-start">{{ 'PLAN_NAME' | translate }}</th>
          <th>{{ 'PURCHASE_DATE' | translate }}</th>
          <th>{{ 'STATUS' | translate }}</th>
          <th>{{ 'ACTION' | translate }}</th>
          <th class="table-end">{{ 'DETAILS' | translate }}</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let plan of plans">
          <tr>
            <td>{{ plan.productName }}</td>
            <td>{{ plan.saleDate }}</td>
            <td>{{ plan.status === 1 ? 'Activo' : 'Inactivo' }}</td>
            <td>
              <button
                *ngIf="plan.status === 1"
                class="remove-btn"
                (click)="togglePlanStatus(plan)">
                {{ 'DISAFFILIATE' | translate }}
              </button>

              <button
                *ngIf="plan.status === 0"
                class="primary-btn"
                (click)="togglePlanStatus(plan)">
                {{ 'AFFILIATE' | translate }}
              </button>
            </td>
            <td>
              <button class="btn btn-link" (click)="toggleExpand(plan)">
                <i class="bi" [ngClass]="{'bi-chevron-down': expandedPlanId !== plan.uniqueId, 'bi-chevron-up': expandedPlanId === plan.uniqueId}"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedPlanId === plan.uniqueId">
            <td colspan="6">
              <div class="plan-details">
                <div class="details-left">
                  <div class="detail-row"><strong>{{ 'ITEM_ID' | translate }}:</strong> {{ plan.itemId }}</div>
                  <div class="detail-row"><strong>{{ 'CODE' | translate }}:</strong> {{ plan.saleOrderCode }}</div>
                  <div class="beneficiaries-section">
                    <h5>{{ 'BENEFICIARIES' | translate }}</h5>
                    <div *ngIf="plan.beneficiaries && plan.beneficiaries.length > 0">
                      <div *ngFor="let beneficiary of plan.beneficiaries" class="beneficiary-item">
                        <p><strong>{{ 'NAME' | translate }}:</strong> {{ beneficiary.beneficiaryName }}</p>
                        <p><strong>{{ 'RELATIONSHIP' | translate }}:</strong> {{ beneficiary.beneficiaryRelationship }}</p>
                        <p *ngIf="beneficiary.beneficiaryGender"><strong>{{ 'GENDER' | translate }}:</strong> {{ beneficiary.beneficiaryGender }}</p>
                        <p *ngIf="beneficiary.beneficiaryBornDate"><strong>{{ 'BIRTH_DATE' | translate }}:</strong> {{ beneficiary.beneficiaryBornDate | date:'dd/MM/yyyy' }}</p>
                      </div>
                    </div>
                    <p *ngIf="!plan.beneficiaries || plan.beneficiaries.length === 0">{{ 'NO_BENEFICIARIES_TEXT' | translate }}</p>
                  </div>
                </div>
                <div class="details-right">
                  <img [src]="plan.imageURL || '/assets/static/missing-image.png'" alt="Imagen del plan" class="plan-image">
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

</div>

<div class="form-card" *ngIf="!loading && !hasPlans && shopSubscription?.shopPlanAllow?.plansByClientBO">
  <div class="title">
    <span>{{ 'CLIENT_PLANS' | translate }}</span>
  </div>
  <div class="no-orders">
    <span>{{ 'NO_PLANS_TEXT' | translate }}</span>
  </div>
</div>

  </div>
</div>

<div class="modal resend-verification-confirm-modal" id="successDisaffiliatePlanModal" tabindex="-1">
  <div class="modal-dialog resend-modal-dialog" role="document">
    <div class="modal-content resend-modal-content">
      <div class="modal-body resend-modal-body">
        <h3 class="text-center">{{"SUCCESS" | translate}}</h3>
        <p class="text-center">{{ 'DISAFFILIATE_PLAN_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal resend-verification-confirm-modal fade" id="errorDisaffiliatePlanModal" tabindex="-1">
  <div class="modal-dialog resend-modal-dialog" role="document">
    <div class="modal-content resend-modal-content">
      <div class="modal-body resend-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}</h3>
        <p class="text-center">{{'ERROR_DISAFFILIATE_PLAN' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal resend-verification-confirm-modal" id="successAffiliatePlanModal" tabindex="-1">
  <div class="modal-dialog resend-modal-dialog" role="document">
    <div class="modal-content resend-modal-content">
      <div class="modal-body resend-modal-body">
        <h3 class="text-center">{{"SUCCESS" | translate}}</h3>
        <p class="text-center">{{ 'AFFILIATE_PLAN_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal resend-verification-confirm-modal fade" id="errorAffiliatePlanModal" tabindex="-1">
  <div class="modal-dialog resend-modal-dialog" role="document">
    <div class="modal-content resend-modal-content">
      <div class="modal-body resend-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}</h3>
        <p class="text-center">{{'ERROR_AFFILIATE_PLAN' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal resend-verification-confirm-modal" id="successResendVerificationModal" tabindex="-1">
  <div class="modal-dialog resend-modal-dialog" role="document">
    <div class="modal-content resend-modal-content">
      <div class="modal-body resend-modal-body">
        <h3 class="text-center">{{"SUCCESS" | translate}}</h3>
        <p class="text-center">{{ 'RESEND_VERIFICATION_EMAIL_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal resend-verification-confirm-modal fade" id="errorResendVerificationModal" tabindex="-1">
  <div class="modal-dialog resend-modal-dialog" role="document">
    <div class="modal-content resend-modal-content">
      <div class="modal-body resend-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}</h3>
        <p class="text-center">{{'ERROR_RESEND_VERIFICATION_EMAIL' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal confirmar cambio de acceso -->
<div
  class="modal fade"
  [class.show]="showAccountAccessModal"
  [style.display]="showAccountAccessModal ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="accountAccessModalLabel"
  [attr.aria-hidden]="!showAccountAccessModal">
  <div
    class="modal-dialog modal-dialog-centered"
    role="document">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h5
          class="modal-title"
          id="accountAccessModalLabel">
          {{"CONFIRM_ACTION" | translate}}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="closeAccountAccessModal()">
        </button>
      </div>
      <!-- Body -->
      <div class="modal-body">
        <p class="mb-0">
          {{ accountAccessMessage }}
        </p>
      </div>
      <!-- Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAccountAccessModal()">
          {{"CANCEL" | translate}}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="confirmAccountAccess()">
          {{"CONFIRM" | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Backdrop -->
<div
  class="modal-backdrop fade"
  [class.show]="showAccountAccessModal"
  *ngIf="showAccountAccessModal">
</div>


<app-footer></app-footer>
